const Type = {
  SET_SIDEBAR_STATE: 'SET_SIDEBAR_STATE',
  SET_SIDEBARNAV_CLICK: 'SET_SIDEBARNAV_CLICK',
  SET_SIDEBARNAV_STATE: 'SET_SIDEBARNAV_STATE',
  SET_PORTFOLIONAV_STATE: 'SET_PORTFOLIONAV_STATE',
  SET_WORK_STATE: 'SET_WORK_STATE',
  BEGIN_DATA_REQUEST: 'BEGIN_DATA_REQUEST',
  SUCCESS_DATA_REQUEST: 'SUCCESS_DATA_REQUEST',
  FAIL_DATA_REQUEST: ' FAIL_DATA_REQUEST',
};

export default Type;
